export default __webpack_public_path__ + "static/media/visualize-insight.683132a0.svg";